<template>
    <div>
        <label class="form-control-label mt-3 pl-1">
            Detail Pembayaran
        </label>
        <div class="alert alert-primary mb-1" role="alert">
            Total Inputan : <strong class="text-nowrap">{{ formatNumber(pembelians.length) }}</strong>
        </div>
        <div class="table-responsive">
            <table class="table">
                <tr>
                    <th class="text-center">No.</th>
                    <th>Kode</th>
                    <th class="text-right">Berat</th>
                    <th class="text-center">Grade</th>
                    <th class="text-right">Harga</th>
                    <th class="text-right">Total</th>
                </tr>
                <tr v-for="(item, index) in pembelians">
                    <th class="text-center text-primary pl-0">
                        {{ index+1 }}
                    </th>
                    <th class="text-primary">
                        {{ formatValue(item.code) }}
                    </th>
                    <th class="text-right text-primary">
                        {{ item.pembayaran_supplier ? formatNumber(item.pembayaran_supplier.berat_akhir) + ' KG' : '-' }}
                    </th>
                    <th class="text-center text-primary pr-0">
                        {{ item.grade ? item.grade.name : '-' }}
                    </th>
                    <th v-if="isEdit || !value.id" class="text-nowrap fit-column text-center text-primary">
                        <input style="width:10rem; max-width: 10rem;" v-validate="'required'" v-model="item.harga" type="number" :name="'bobot'+index" class="form-control text-right" @input="updateDetails">
                        <span class="text-danger">{{ errors.first('bobot'+index) }}</span>
                    </th>
                    <th v-else class="text-right text-primary">
                        {{ formatNumber(item.pembayaran_supplier && item.pembayaran_supplier.nota_supplier_item ? item.pembayaran_supplier.nota_supplier_item.harga : item.harga) }}
                    </th>
                    <th class="text-right text-primary">
                        {{ formatNumber(item.harga * item.pembayaran_supplier.berat_akhir) }}
                    </th>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: "nota-supplier-detail",

    props: {
        value: {
            type: Object,
            default: () => {},
        },

        isEdit: {
            type: Boolean,
            default: false,
        },
    },

    components: {
    },

    data() {
        return {
            pembelians: [],
        }
    },

    created() {
    },

    mounted() {
        this.pembelians = Object.assign([], this.value.pembelians);
        if (this.value.id && !this.isEdit) {
            this.loadDetails();
        } else {
            this.setItemHarga();
        }
        this.updateDetails();
    },

    computed: {
    },

    watch: {
    },

    methods: {
        loadDetails() {
            let self = this;

            self.isLoading = true;
            self.$Progress.start();
            axios({
                method: 'get',
                url: '/api/pembelian-tembakaus/nota-supplier/'+self.value.id+'/details',
            })
            .then(function (response) {
                self.isLoading = false;
                self.$Progress.finish();
                self.pembelians = Object.assign([], response.data.data);
                self.setItemHarga();
                self.$emit('loaded', self.pembelians);
            })
            .catch(function (error) {
                self.requestFailed(error);
            });
        },

        setItemHarga() {
            this.pembelians.forEach((pembelian, index) => {
                if (!pembelian.harga) {
                    this.pembelians[index].harga = pembelian.pembayaran_supplier.nota_supplier_item ? pembelian.pembayaran_supplier.nota_supplier_item.harga : pembelian.pembayaran_supplier.harga_per_kg;
                }
            });
        },

        updateDetails() {
            this.$emit('update-details', this.pembelians);
        },
    },
}
</script>
<style>
.fit-column {
    width: 0.1%;
    white-space: nowrap;
}

th, td {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
}
</style>
